// @flow

import { Map as ImmutableMap } from 'immutable';
import {
  GET_FLIGHTS_SUCCESS,
  GET_FLIGHTS_FAIL,
  DELETE_FLIGHT_SUCCESS,
  DELETE_FLIGHT_FAIL,
  EDIT_FLIGHT_SUCCESS,
  EDIT_FLIGHT_FAIL,
  ADD_FLIGHT_SUCCESS,
  ADD_FLIGHT_FAIL,
  CLEAR_FLIGHT_MANAGER_ERROR,
  SELECT_FLIGHT,
  SET_CHOSEN_FLIGHT_BY_ID,
  START_FLIGHT_SUCCESS,
  START_FLIGHT_FAIL,
  FINISH_FLIGHT_SUCCESS,
  FINISH_FLIGHT_FAIL,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAIL,
  GET_TIME_ZONES_SUCCESS,
  GET_TIME_ZONES_FAIL,
  SET_FLIGHT_GEOMETRY_TYPE,
} from './../types/flightManager';

import {
  SIGN_OUT,
} from './../types/auth';

const INITIAL_STATE = ImmutableMap({
  rawData: [],
  message: { text: '', type: 'info' },
  chosenFlight: null,
  updateType: "",
  flightGeometryType: 'Point',
});

type Error = {
  message: string;
};

type FlightData = {
  type: string,
  error: Error,
  rawDataArray?: Array<any>,
  editedRowData: any,
  id?: string,
  chosenFlight?: any
};

let editedData = [];

const FlightManagerReducer = (state: ImmutableMap<string, any> = INITIAL_STATE, action: FlightData) => {
  switch (action.type) {
    case GET_FLIGHTS_SUCCESS:
      return state
        .set('rawData', action.rawDataArray)
        .set('updateType', GET_FLIGHTS_SUCCESS);

    case GET_FLIGHTS_FAIL:
      return state
        .set('message', { text: action.error.response.data, type: 'error' });

    case DELETE_FLIGHT_SUCCESS:
      const rawData = state.get('rawData').filter(row =>
        row.id !== action.id
      );
      return state
        .set('chosenFlight', rawData[0])
        .set('rawData', rawData)
        .set('updateType', DELETE_FLIGHT_SUCCESS);

    case DELETE_FLIGHT_FAIL:
      return state
        .set('message', { text: action.error.response.data, type: 'error' });

    case EDIT_FLIGHT_SUCCESS:
      editedData = state.get('rawData').map(row => {
        if (row.id === action.editedRowData.id) {
          row = action.editedRowData;
        }
        return row;
      });
      return state
        .set('chosenFlight', action.editedRowData)
        .set('rawData', editedData)
        .set('message',
          {
            text: 'Mission edited',
            status: 'info'
          })
        .set('updateType', EDIT_FLIGHT_SUCCESS);

    case EDIT_FLIGHT_FAIL:
      return state
        .set('message', { text: action.error.response.data, type: 'error' })
        .set('updateType', EDIT_FLIGHT_FAIL);

    case ADD_FLIGHT_SUCCESS:
      const updatedData = state.get('rawData').concat([action.editedRowData]);

      return state
        .set('chosenFlight', action.editedRowData)
        .set('rawData', updatedData)
        .set('message',
          {
            text: 'Mission added',
            status: 'info'
          })
        .set('updateType', ADD_FLIGHT_SUCCESS);

    case ADD_FLIGHT_FAIL:
      return state
        .set('message', { text: action.error.response.data, type: 'error' })
        .set('updateType', ADD_FLIGHT_FAIL);

    case CLEAR_FLIGHT_MANAGER_ERROR:
      return state
        .set('message', { text: '', type: 'info' })
        .set('updateType', CLEAR_FLIGHT_MANAGER_ERROR);

    case SELECT_FLIGHT:
      return state
        .set('chosenFlight', action.chosenFlight)
        .set('updateType', SELECT_FLIGHT);

    case SET_CHOSEN_FLIGHT_BY_ID:
      const flight = state.get('rawData').find(row => {
        return row.id === action.id;
      });
      return state
        .set('chosenFlight', flight)
        .set('updateType', SELECT_FLIGHT);

    case START_FLIGHT_SUCCESS:
      editedData = state.get('rawData').map(row => {
        if (row.id === action.id) {
          row.flightStatus = 3;
        }
        return row;
      });
      return state
        .set('rawData', editedData)
        .set('updateType', START_FLIGHT_SUCCESS);

    case START_FLIGHT_FAIL:
      return state
        .set('message', { text: action.error.response.data, type: 'error' })
        .set('updateType', START_FLIGHT_FAIL);

    case FINISH_FLIGHT_SUCCESS:
      editedData = state.get('rawData').map(row => {
        if (row.id === action.id) {
          row.flightStatus = 4;
        }
        return row;
      });
      return state
        .set('rawData', editedData)
        .set('updateType', FINISH_FLIGHT_SUCCESS);

    case FINISH_FLIGHT_FAIL:
      return state
        .set('message', { text: action.error.response.data, type: 'error' })
        .set('updateType', FINISH_FLIGHT_FAIL);

    case GET_PRODUCTS_SUCCESS:
      return state
        .set('products', action.rawDataArray)
        .set('updateType', GET_PRODUCTS_SUCCESS);

    case GET_PRODUCTS_FAIL:
      return state
        .set('message', { text: action.error.response.data, type: 'error' });

    case GET_TIME_ZONES_SUCCESS:
        return state
          .set('timeZonesNames', action.rawDataArray)
          .set('updateType', GET_TIME_ZONES_SUCCESS);
  
      case GET_TIME_ZONES_FAIL:
        return state
          .set('message', { text: action.error.response.data, type: 'error' });

    case SET_FLIGHT_GEOMETRY_TYPE:
      return state
        .set('flightGeometryType', action.flightGeometryType)

    case SIGN_OUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default FlightManagerReducer;


// WEBPACK FOOTER //
// ./src/reducers/flightManager.jsx